import { ArrowLeftOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Empty, Spin, Typography } from "antd";
import {
  checkSignContractById,
  downloadContractById,
  getContractById,
  getContractPdfById,
  signContractById,
} from "entities/contracts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ROUTES from "shared/routes";
import { SingDocument, ViewDocument } from "widgets/sign-document";
import styles from "./index.module.scss";

export const SingContractsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { contractId } = useParams();
  const [shouldPoll, setShouldPoll] = useState(false);

  const {
    data: contract,
    isLoading: isLoadingContract,
    isError: isErrorContract,
    error,
  } = useQuery({
    queryKey: ["contract", contractId],
    queryFn: () => getContractById(contractId!),
    enabled: !!contractId,
    refetchInterval: (query) => {
      const status = query.state.data?.edo_status?.code;
      return shouldPoll && status !== "FINISHED" ? 5000 : false;
    },
  });

  if (isLoadingContract) {
    return (
      <div className={styles.wrapperLoader}>
        <Spin />
      </div>
    );
  }

  if (isErrorContract || !contract || !contractId) {
    return (
      <div className={styles.wrapper}>
        <Typography.Title level={3}>
          <Button
            type="link"
            size="large"
            onClick={() => navigate(ROUTES.CONTRACTS)}
          ></Button>
          {t("sign_contract.title")}
        </Typography.Title>
        <Empty
          description={
            <Typography.Text>
              {isErrorContract
                ? (error as any)?.response?.data?.message ||
                  t("sign_contract.document_load_error")
                : t("sign_contract.document_not_found")}
            </Typography.Text>
          }
        />
      </div>
    );
  }

  return (
    <>
      <Typography.Title level={3}>
        <Button
          type="link"
          size="large"
          icon={
            <ArrowLeftOutlined style={{ fontSize: "20px", marginRight: 8 }} />
          }
          onClick={() => navigate(ROUTES.CONTRACTS)}
        ></Button>
        {t("sign_contract.title")}
        <br />
      </Typography.Title>

      <ViewDocument
        documentId={contractId}
        localeKey={"sign_contract"}
        getDocumentPdfById={getContractPdfById}
        downloadDocumentById={downloadContractById}
      />
      <SingDocument
        document={contract}
        localeKey={"sign_contract"}
        setShouldPoll={setShouldPoll}
        signDocumentById={signContractById}
        checkSignDocumentById={checkSignContractById}
      />
    </>
  );
};
